let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cbucA")).then(() => parcelRequire('e6WCz'));